import React from 'react';
import {Box, Button, Card, CardActions, CardContent, CardHeader, SvgIcon} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Graph from "../../icons/untitled-ui/duocolor/graph";
import MarkdownIt from "markdown-it";
import localStrings from "../../localStrings";

export const type_chart = 'chart';
export const type_dataGrid = 'dataGrid';

function ChartPresentationItem({item, addItemCallBack}) {

    const mdParser = new MarkdownIt(/* Markdown-it options */);

    function getMediaUrl() {
        return item.chartMediaUrl || item.mediaUrl;
    }

    return (
        <div style={{width: '100%'}}>
            <Card sx={{
                width: '100%',
                border: '2px solid #e0e0e0',
                marginBottom: '5px',
            }}>
                <CardHeader
                    title={item.name}
                />
                <CardMedia
                >

                    <Box sx={{
                        margin: '10px',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        {getMediaUrl() && getMediaUrl() !== "" ?
                            <img src={getMediaUrl()} width={'80%'}/>
                            :
                            <SvgIcon fontSize="large">
                                {/*{type === type_dataGrid &&*/}
                                {/*    <Graph/>*/}
                                {/*}*/}
                                {/*{type === type_chart &&*/}
                                {/*    <Graph/>*/}
                                {/*}*/}
                                <Graph/>
                            </SvgIcon>
                        }
                    </Box>


                </CardMedia>

                <CardContent>
                    {item.mdDescription &&
                        <div
                            dangerouslySetInnerHTML={{__html: mdParser.render(item.mdDescription)}}
                        />
                    }
                </CardContent>

                <CardActions>
                    <div style={{width: '100%'}}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row-reverse',
                                p: 1,
                                m: 1,
                                borderRadius: 1,
                            }}
                        >
                            <Box>

                                <Button
                                    variant={"contained"}
                                    onClick={() => {
                                        addItemCallBack(item)
                                    }}
                                >
                                    {localStrings.addToDashBoard}
                                </Button>
                            </Box>
                        </Box>
                    </div>
                </CardActions>
            </Card>
        </div>
    )
}

export default ChartPresentationItem